document.addEventListener('change', function (e) {
  const select = e.target.closest('.product__info-container .product-card-addon .addon-select-product');
  if (!select) return;
  const selectedOption = select.options[select.selectedIndex];
  const imageUrl = selectedOption.getAttribute('data-image');
  if (imageUrl) {
    const parent = select.closest('.product-card-addon');
    const img = parent.querySelector('.product-image img');
    if (img) {
      img.srcset = imageUrl;
      img.src = imageUrl;
    }
  }
});

// Dynamic Price Calculator for Shopify Dawn Theme
// Handles personalized name plate, toggle switches, and quantity

document.addEventListener('DOMContentLoaded', function() {
  const productContainer = document.querySelector('.product__info-container');
  // Get base product price (in cents)
  const priceDisplays = document.querySelectorAll('.product__info-container .custom-price span');
  if (!priceDisplays.length) return;
  // Get form elements
  
  const quantityInput = productContainer.querySelector('.quantity__input');
  //const addonProducts = document.querySelectorAll('.product-card-addon');
  function calculateTotal() {
    const nameInput = document.querySelector('#personalised-name-plate-text');
    let basePrice =  0;
    
    document.querySelectorAll('.product__info-container .custom-price span').forEach(priceDisplay => {
      basePrice = parseInt(priceDisplay.dataset.price);
    });
    //const basePrice = parseInt(priceDisplays[0]?.dataset.price || 0);

    let total = basePrice;
     ///console.log('total ' + total);
    // Check if personalized name plate has text
    if (nameInput && nameInput.value.trim() !== '') {
      const namePlatePrice = parseInt(nameInput.dataset.price || 0);
      total += namePlatePrice;
    }
    //console.log('total 1 ' + total);
    // // Add prices from active toggle switches
    document.querySelectorAll('.product-card-addon').forEach(addonProduct => {
      // Check if toggle is active/checked
      const addonProductToggle = addonProduct.querySelector('.toggle-switch');
      const addonProductSelect = addonProduct.querySelector('.addon-select-product');

      if (addonProductSelect ) {
        let addonPrice = 0;
        // If selected option is not blank, get price from selected option
        const selectedOption = addonProductSelect.options[addonProductSelect.selectedIndex];
        if (selectedOption && selectedOption.value !== "") {
          addonPrice = parseInt(selectedOption.dataset.price || 0);
        } 

        const discountText = selectedOption.dataset.discountText; 
        const discountTextSpan = addonProduct.querySelector('.discount-badge');
        if( discountText && discountTextSpan ){
           discountTextSpan.textContent = discountText;
        }

        const priceEl = addonProduct.querySelector('.product-price');
        if (priceEl) {
          priceEl.dataset.price = addonPrice;      // update data-price
          priceEl.textContent = `+$${(addonPrice/100).toFixed(2)}`; // update visible price
        }
        if (addonProductToggle && !addonProductToggle.disabled && addonProductToggle.checked) {
         total += addonPrice;
        }
         ///console.log('total 3 ' + total);
      }
       ///console.log('total 4 ' + total);
    });
    //console.log('total 2 ' + total);
    // Multiply by quantity
    const quantity = parseInt(quantityInput?.value || 1);
    
    const finalTotal = total * quantity;
    ///alert(total + ' ' + quantity + ' ' + finalTotal ); 
    // Update price display
    //console.log('finalTotal ' + total);
    updatePriceDisplay(finalTotal);
    
    return finalTotal;
  }

  function hidePriceBlock(){
    const parents = document.querySelectorAll('.price_container_custom');

    if (!parents.length) return;

    parents.forEach(parent => {
      const customPrice = parent.querySelector('.custom-price');
      const defaultPrice = parent.querySelector('.price__container');

      if (customPrice) customPrice.style.display = 'block';
      if (defaultPrice) defaultPrice.style.display = 'none';
    });

  }
  
  function updatePriceDisplay(priceInCents) {
    document.querySelectorAll('.product__info-container .custom-price span').forEach(priceDisplay => {
      const priceInDollars = (priceInCents / 100).toFixed(2);
       priceDisplay.textContent = '$' + priceInDollars;
    });

    hidePriceBlock();
  }

  // Re-validate all addons and show/hide error below Add to Cart
  function validateAddonsAndUpdateError() {
    const addonsSection = document.querySelector(".product-custom-addons-wrapper");
    const productForm = document.querySelector("product-form");
    if (!addonsSection || !productForm?.handleErrorMessage) return;
    addonsSection.querySelectorAll(".addon-select-product").forEach(function (s) {
      s.classList.remove("addon-select-product--error");
    });
    const invalidTitles = [];
    addonsSection.querySelectorAll(".product-card-addon").forEach(function (addonBlock) {
      const toggle = addonBlock.querySelector(".toggle-switch");
      const select = addonBlock.querySelector(".addon-select-product");
      if (toggle && !toggle.disabled && toggle.checked && select && !select.value.trim()) {
        select.classList.add("addon-select-product--error");
        const title = select.getAttribute("data-product-title");
        if (title) invalidTitles.push(title);
      }
    });
    if (invalidTitles.length > 0) {
      const message = invalidTitles.length === 1
        ? 'Please choose an option for "' + invalidTitles[0] + '".'
        : "Please choose an option for: " + invalidTitles.map(function (t) { return '"' + t + '"'; }).join(" and ") + ".";
      productForm.handleErrorMessage(message);
    } else {
      productForm.handleErrorMessage();
    }
  }

  document.addEventListener("change", function (e) {
    if (e.target.matches("#personalised-name-plate-text")) {
      calculateTotal();
    }

    if (e.target.matches(".addon-select-product")) {
      validateAddonsAndUpdateError();
      calculateTotal();
    }

    if (e.target.matches(".toggle-switch")) {
      validateAddonsAndUpdateError();
      calculateTotal();
    }
  });

  // Re-validate when toggle area is clicked (in case change fires before DOM updates)
  document.addEventListener("click", function (e) {
    const toggle = e.target.closest(".product-card-addon .toggle-container");
    if (toggle) {
      setTimeout(function () { validateAddonsAndUpdateError(); }, 0);
    }
  }, true);

  document.addEventListener("input", function (e) {
    if (e.target.matches(".quantity__input")) {
      calculateTotal();
    }
    if (e.target.matches("#personalised-name-plate-text")) {
      calculateTotal();
    }
  });

document.addEventListener("click", function (e) {
  if (e.target.closest(".quantity__button")) {
    setTimeout(calculateTotal, 50);
  }
});
  
});